import script from "./OveruseNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./OveruseNotifications.vue?vue&type=script&setup=true&lang=js"

import "./OveruseNotifications.vue?vue&type=style&index=0&id=24ca092a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ca092a"]])

export default __exports__